/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as RepertoireRouteImport } from './routes/repertoire'
import { Route as PracticeRouteImport } from './routes/practice'
import { Route as PiecesRouteImport } from './routes/pieces'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LibraryRouteImport } from './routes/library'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as DevTakesFixturesRouteImport } from './routes/dev-takes-fixtures'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as RepertoireNewRouteImport } from './routes/repertoire_.new'
import { Route as RepertoireAddRouteImport } from './routes/repertoire_.add'
import { Route as RepertoireArrangementIdRouteImport } from './routes/repertoire_.$arrangementId'
import { Route as PiecesPieceIdRouteImport } from './routes/pieces_.$pieceId'
import { Route as LibraryContributeRouteImport } from './routes/library_.contribute'
import { Route as LibraryPieceIdRouteImport } from './routes/library_.$pieceId'
import { Route as AdminSplatRouteImport } from './routes/admin.$'
import { Route as AdminReferenceTakesIndexRouteImport } from './routes/admin.reference-takes.index'
import { Route as AdminQueueIndexRouteImport } from './routes/admin.queue.index'
import { Route as RepertoireArrangementIdEditRouteImport } from './routes/repertoire_.$arrangementId_.edit'
import { Route as AdminReferenceTakesIdRouteImport } from './routes/admin.reference-takes.$id'
import { Route as AdminQueuePieceIdRouteImport } from './routes/admin.queue.$pieceId'
import { Route as AdminPiecesEditRouteImport } from './routes/admin.pieces.edit'
import { Route as PracticeSessionsSessionIdSummaryRouteImport } from './routes/practice_.sessions_.$sessionId_.summary'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const RepertoireRoute = RepertoireRouteImport.update({
  id: '/repertoire',
  path: '/repertoire',
  getParentRoute: () => rootRouteImport,
} as any)
const PracticeRoute = PracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => rootRouteImport,
} as any)
const PiecesRoute = PiecesRouteImport.update({
  id: '/pieces',
  path: '/pieces',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryRoute = LibraryRouteImport.update({
  id: '/library',
  path: '/library',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const DevTakesFixturesRoute = DevTakesFixturesRouteImport.update({
  id: '/dev-takes-fixtures',
  path: '/dev-takes-fixtures',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const RepertoireNewRoute = RepertoireNewRouteImport.update({
  id: '/repertoire_/new',
  path: '/repertoire/new',
  getParentRoute: () => rootRouteImport,
} as any)
const RepertoireAddRoute = RepertoireAddRouteImport.update({
  id: '/repertoire_/add',
  path: '/repertoire/add',
  getParentRoute: () => rootRouteImport,
} as any)
const RepertoireArrangementIdRoute = RepertoireArrangementIdRouteImport.update({
  id: '/repertoire_/$arrangementId',
  path: '/repertoire/$arrangementId',
  getParentRoute: () => rootRouteImport,
} as any)
const PiecesPieceIdRoute = PiecesPieceIdRouteImport.update({
  id: '/pieces_/$pieceId',
  path: '/pieces/$pieceId',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryContributeRoute = LibraryContributeRouteImport.update({
  id: '/library_/contribute',
  path: '/library/contribute',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryPieceIdRoute = LibraryPieceIdRouteImport.update({
  id: '/library_/$pieceId',
  path: '/library/$pieceId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSplatRoute = AdminSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => AdminRoute,
} as any)
const AdminReferenceTakesIndexRoute =
  AdminReferenceTakesIndexRouteImport.update({
    id: '/reference-takes/',
    path: '/reference-takes/',
    getParentRoute: () => AdminRoute,
  } as any)
const AdminQueueIndexRoute = AdminQueueIndexRouteImport.update({
  id: '/queue/',
  path: '/queue/',
  getParentRoute: () => AdminRoute,
} as any)
const RepertoireArrangementIdEditRoute =
  RepertoireArrangementIdEditRouteImport.update({
    id: '/repertoire_/$arrangementId_/edit',
    path: '/repertoire/$arrangementId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminReferenceTakesIdRoute = AdminReferenceTakesIdRouteImport.update({
  id: '/reference-takes/$id',
  path: '/reference-takes/$id',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQueuePieceIdRoute = AdminQueuePieceIdRouteImport.update({
  id: '/queue/$pieceId',
  path: '/queue/$pieceId',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPiecesEditRoute = AdminPiecesEditRouteImport.update({
  id: '/pieces/edit',
  path: '/pieces/edit',
  getParentRoute: () => AdminRoute,
} as any)
const PracticeSessionsSessionIdSummaryRoute =
  PracticeSessionsSessionIdSummaryRouteImport.update({
    id: '/practice_/sessions_/$sessionId_/summary',
    path: '/practice/sessions/$sessionId/summary',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dev-takes-fixtures': typeof DevTakesFixturesRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/pieces': typeof PiecesRoute
  '/practice': typeof PracticeRoute
  '/repertoire': typeof RepertoireRoute
  '/settings': typeof SettingsRoute
  '/admin/$': typeof AdminSplatRoute
  '/library/$pieceId': typeof LibraryPieceIdRoute
  '/library/contribute': typeof LibraryContributeRoute
  '/pieces/$pieceId': typeof PiecesPieceIdRoute
  '/repertoire/$arrangementId': typeof RepertoireArrangementIdRoute
  '/repertoire/add': typeof RepertoireAddRoute
  '/repertoire/new': typeof RepertoireNewRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/pieces/edit': typeof AdminPiecesEditRoute
  '/admin/queue/$pieceId': typeof AdminQueuePieceIdRoute
  '/admin/reference-takes/$id': typeof AdminReferenceTakesIdRoute
  '/repertoire/$arrangementId/edit': typeof RepertoireArrangementIdEditRoute
  '/admin/queue/': typeof AdminQueueIndexRoute
  '/admin/reference-takes/': typeof AdminReferenceTakesIndexRoute
  '/practice/sessions/$sessionId/summary': typeof PracticeSessionsSessionIdSummaryRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/dev-takes-fixtures': typeof DevTakesFixturesRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/pieces': typeof PiecesRoute
  '/practice': typeof PracticeRoute
  '/repertoire': typeof RepertoireRoute
  '/settings': typeof SettingsRoute
  '/admin/$': typeof AdminSplatRoute
  '/library/$pieceId': typeof LibraryPieceIdRoute
  '/library/contribute': typeof LibraryContributeRoute
  '/pieces/$pieceId': typeof PiecesPieceIdRoute
  '/repertoire/$arrangementId': typeof RepertoireArrangementIdRoute
  '/repertoire/add': typeof RepertoireAddRoute
  '/repertoire/new': typeof RepertoireNewRoute
  '/admin': typeof AdminIndexRoute
  '/admin/pieces/edit': typeof AdminPiecesEditRoute
  '/admin/queue/$pieceId': typeof AdminQueuePieceIdRoute
  '/admin/reference-takes/$id': typeof AdminReferenceTakesIdRoute
  '/repertoire/$arrangementId/edit': typeof RepertoireArrangementIdEditRoute
  '/admin/queue': typeof AdminQueueIndexRoute
  '/admin/reference-takes': typeof AdminReferenceTakesIndexRoute
  '/practice/sessions/$sessionId/summary': typeof PracticeSessionsSessionIdSummaryRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/dev-takes-fixtures': typeof DevTakesFixturesRoute
  '/history': typeof HistoryRoute
  '/library': typeof LibraryRoute
  '/login': typeof LoginRoute
  '/pieces': typeof PiecesRoute
  '/practice': typeof PracticeRoute
  '/repertoire': typeof RepertoireRoute
  '/settings': typeof SettingsRoute
  '/admin/$': typeof AdminSplatRoute
  '/library_/$pieceId': typeof LibraryPieceIdRoute
  '/library_/contribute': typeof LibraryContributeRoute
  '/pieces_/$pieceId': typeof PiecesPieceIdRoute
  '/repertoire_/$arrangementId': typeof RepertoireArrangementIdRoute
  '/repertoire_/add': typeof RepertoireAddRoute
  '/repertoire_/new': typeof RepertoireNewRoute
  '/admin/': typeof AdminIndexRoute
  '/admin/pieces/edit': typeof AdminPiecesEditRoute
  '/admin/queue/$pieceId': typeof AdminQueuePieceIdRoute
  '/admin/reference-takes/$id': typeof AdminReferenceTakesIdRoute
  '/repertoire_/$arrangementId_/edit': typeof RepertoireArrangementIdEditRoute
  '/admin/queue/': typeof AdminQueueIndexRoute
  '/admin/reference-takes/': typeof AdminReferenceTakesIndexRoute
  '/practice_/sessions_/$sessionId_/summary': typeof PracticeSessionsSessionIdSummaryRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/dev-takes-fixtures'
    | '/history'
    | '/library'
    | '/login'
    | '/pieces'
    | '/practice'
    | '/repertoire'
    | '/settings'
    | '/admin/$'
    | '/library/$pieceId'
    | '/library/contribute'
    | '/pieces/$pieceId'
    | '/repertoire/$arrangementId'
    | '/repertoire/add'
    | '/repertoire/new'
    | '/admin/'
    | '/admin/pieces/edit'
    | '/admin/queue/$pieceId'
    | '/admin/reference-takes/$id'
    | '/repertoire/$arrangementId/edit'
    | '/admin/queue/'
    | '/admin/reference-takes/'
    | '/practice/sessions/$sessionId/summary'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/dev-takes-fixtures'
    | '/history'
    | '/library'
    | '/login'
    | '/pieces'
    | '/practice'
    | '/repertoire'
    | '/settings'
    | '/admin/$'
    | '/library/$pieceId'
    | '/library/contribute'
    | '/pieces/$pieceId'
    | '/repertoire/$arrangementId'
    | '/repertoire/add'
    | '/repertoire/new'
    | '/admin'
    | '/admin/pieces/edit'
    | '/admin/queue/$pieceId'
    | '/admin/reference-takes/$id'
    | '/repertoire/$arrangementId/edit'
    | '/admin/queue'
    | '/admin/reference-takes'
    | '/practice/sessions/$sessionId/summary'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/dev-takes-fixtures'
    | '/history'
    | '/library'
    | '/login'
    | '/pieces'
    | '/practice'
    | '/repertoire'
    | '/settings'
    | '/admin/$'
    | '/library_/$pieceId'
    | '/library_/contribute'
    | '/pieces_/$pieceId'
    | '/repertoire_/$arrangementId'
    | '/repertoire_/add'
    | '/repertoire_/new'
    | '/admin/'
    | '/admin/pieces/edit'
    | '/admin/queue/$pieceId'
    | '/admin/reference-takes/$id'
    | '/repertoire_/$arrangementId_/edit'
    | '/admin/queue/'
    | '/admin/reference-takes/'
    | '/practice_/sessions_/$sessionId_/summary'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  DevTakesFixturesRoute: typeof DevTakesFixturesRoute
  HistoryRoute: typeof HistoryRoute
  LibraryRoute: typeof LibraryRoute
  LoginRoute: typeof LoginRoute
  PiecesRoute: typeof PiecesRoute
  PracticeRoute: typeof PracticeRoute
  RepertoireRoute: typeof RepertoireRoute
  SettingsRoute: typeof SettingsRoute
  LibraryPieceIdRoute: typeof LibraryPieceIdRoute
  LibraryContributeRoute: typeof LibraryContributeRoute
  PiecesPieceIdRoute: typeof PiecesPieceIdRoute
  RepertoireArrangementIdRoute: typeof RepertoireArrangementIdRoute
  RepertoireAddRoute: typeof RepertoireAddRoute
  RepertoireNewRoute: typeof RepertoireNewRoute
  RepertoireArrangementIdEditRoute: typeof RepertoireArrangementIdEditRoute
  PracticeSessionsSessionIdSummaryRoute: typeof PracticeSessionsSessionIdSummaryRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/repertoire': {
      id: '/repertoire'
      path: '/repertoire'
      fullPath: '/repertoire'
      preLoaderRoute: typeof RepertoireRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/practice': {
      id: '/practice'
      path: '/practice'
      fullPath: '/practice'
      preLoaderRoute: typeof PracticeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pieces': {
      id: '/pieces'
      path: '/pieces'
      fullPath: '/pieces'
      preLoaderRoute: typeof PiecesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library': {
      id: '/library'
      path: '/library'
      fullPath: '/library'
      preLoaderRoute: typeof LibraryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev-takes-fixtures': {
      id: '/dev-takes-fixtures'
      path: '/dev-takes-fixtures'
      fullPath: '/dev-takes-fixtures'
      preLoaderRoute: typeof DevTakesFixturesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/repertoire_/new': {
      id: '/repertoire_/new'
      path: '/repertoire/new'
      fullPath: '/repertoire/new'
      preLoaderRoute: typeof RepertoireNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/repertoire_/add': {
      id: '/repertoire_/add'
      path: '/repertoire/add'
      fullPath: '/repertoire/add'
      preLoaderRoute: typeof RepertoireAddRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/repertoire_/$arrangementId': {
      id: '/repertoire_/$arrangementId'
      path: '/repertoire/$arrangementId'
      fullPath: '/repertoire/$arrangementId'
      preLoaderRoute: typeof RepertoireArrangementIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pieces_/$pieceId': {
      id: '/pieces_/$pieceId'
      path: '/pieces/$pieceId'
      fullPath: '/pieces/$pieceId'
      preLoaderRoute: typeof PiecesPieceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library_/contribute': {
      id: '/library_/contribute'
      path: '/library/contribute'
      fullPath: '/library/contribute'
      preLoaderRoute: typeof LibraryContributeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library_/$pieceId': {
      id: '/library_/$pieceId'
      path: '/library/$pieceId'
      fullPath: '/library/$pieceId'
      preLoaderRoute: typeof LibraryPieceIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/$': {
      id: '/admin/$'
      path: '/$'
      fullPath: '/admin/$'
      preLoaderRoute: typeof AdminSplatRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/reference-takes/': {
      id: '/admin/reference-takes/'
      path: '/reference-takes'
      fullPath: '/admin/reference-takes/'
      preLoaderRoute: typeof AdminReferenceTakesIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/queue/': {
      id: '/admin/queue/'
      path: '/queue'
      fullPath: '/admin/queue/'
      preLoaderRoute: typeof AdminQueueIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/repertoire_/$arrangementId_/edit': {
      id: '/repertoire_/$arrangementId_/edit'
      path: '/repertoire/$arrangementId/edit'
      fullPath: '/repertoire/$arrangementId/edit'
      preLoaderRoute: typeof RepertoireArrangementIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/reference-takes/$id': {
      id: '/admin/reference-takes/$id'
      path: '/reference-takes/$id'
      fullPath: '/admin/reference-takes/$id'
      preLoaderRoute: typeof AdminReferenceTakesIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/queue/$pieceId': {
      id: '/admin/queue/$pieceId'
      path: '/queue/$pieceId'
      fullPath: '/admin/queue/$pieceId'
      preLoaderRoute: typeof AdminQueuePieceIdRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/pieces/edit': {
      id: '/admin/pieces/edit'
      path: '/pieces/edit'
      fullPath: '/admin/pieces/edit'
      preLoaderRoute: typeof AdminPiecesEditRouteImport
      parentRoute: typeof AdminRoute
    }
    '/practice_/sessions_/$sessionId_/summary': {
      id: '/practice_/sessions_/$sessionId_/summary'
      path: '/practice/sessions/$sessionId/summary'
      fullPath: '/practice/sessions/$sessionId/summary'
      preLoaderRoute: typeof PracticeSessionsSessionIdSummaryRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminSplatRoute: typeof AdminSplatRoute
  AdminIndexRoute: typeof AdminIndexRoute
  AdminPiecesEditRoute: typeof AdminPiecesEditRoute
  AdminQueuePieceIdRoute: typeof AdminQueuePieceIdRoute
  AdminReferenceTakesIdRoute: typeof AdminReferenceTakesIdRoute
  AdminQueueIndexRoute: typeof AdminQueueIndexRoute
  AdminReferenceTakesIndexRoute: typeof AdminReferenceTakesIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminSplatRoute: AdminSplatRoute,
  AdminIndexRoute: AdminIndexRoute,
  AdminPiecesEditRoute: AdminPiecesEditRoute,
  AdminQueuePieceIdRoute: AdminQueuePieceIdRoute,
  AdminReferenceTakesIdRoute: AdminReferenceTakesIdRoute,
  AdminQueueIndexRoute: AdminQueueIndexRoute,
  AdminReferenceTakesIndexRoute: AdminReferenceTakesIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  DevTakesFixturesRoute: DevTakesFixturesRoute,
  HistoryRoute: HistoryRoute,
  LibraryRoute: LibraryRoute,
  LoginRoute: LoginRoute,
  PiecesRoute: PiecesRoute,
  PracticeRoute: PracticeRoute,
  RepertoireRoute: RepertoireRoute,
  SettingsRoute: SettingsRoute,
  LibraryPieceIdRoute: LibraryPieceIdRoute,
  LibraryContributeRoute: LibraryContributeRoute,
  PiecesPieceIdRoute: PiecesPieceIdRoute,
  RepertoireArrangementIdRoute: RepertoireArrangementIdRoute,
  RepertoireAddRoute: RepertoireAddRoute,
  RepertoireNewRoute: RepertoireNewRoute,
  RepertoireArrangementIdEditRoute: RepertoireArrangementIdEditRoute,
  PracticeSessionsSessionIdSummaryRoute: PracticeSessionsSessionIdSummaryRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
